module.exports = __webpack_public_path__ + "static/media/left-caret-clinician-nav.3257668d.svg";